import Action from '../Action'
import './styles/ModalCreateRelationTechDevice.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import InputAdmin from '../InputAdmin';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
const ModalCreateRelationTechDevice =({dataActionRel,setDataActionRel,languaje,mode,msgError,setMsgError,IpValid,setIpValid,user,dataCisConf,server,arrayHost,setArraySeverity,arraySeverity,setArrayHost,registerIsValid,setRegisterIsValid,tecSelected,closCreateRelationModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [loading,setLoading]=useState(false);
    // const [registerIsValid,setRegisterIsValid]=useState(false)

    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState({})
    const hostIdsActual = dataCisConf.data.devices.map(obj => obj.hostid);

    const [severity,setSeverity]=useState(0)
    const dataCriticalities=useFetch('cassia/criticalities','','','GET',server)
    const [hostName,setHostName]=useState("")
    const [ip,setIp]=useState("")
    const handleChange=(e)=>{
        const {name,value}=e.target


        setIp(value)

        if(e.target.name==="ip"){
            
            setIpValid(validateIp(value))
           
          }
    }
    useEffect(()=>{
     sethost([])
},[IpValid])
    useEffect(()=>{
     
          if((IpValid==false && host.length===0)|| ip==""){
              setDisabled(true)
          }else{
              setDisabled(false)
          }
    },[host])

    //       useEffect(()=>{

    //         if(registerIsValid){
    //             closCreateRelationModal()
    //         }
    //   },[registerIsValid])
    const Agregar=()=>{
        
        if (hostIdsActual.includes(host.hostid)) {
            setMsgError('Dispositivo ya fue agregado')
            setIpValid(false)
            sethost({})
            // setIp("")
        } else {
            setIpValid(true)
            setArrayHost([...arrayHost,host])
            setDataActionRel([...dataActionRel,host])
            setArraySeverity([...arraySeverity,severity])
            setSeverity(0)
            sethost({})
            setIp("")
        }
        
    }
    const Borrar=()=>{
        sethost({})
        setIp("")
        setSeverity(0)
    }
    const Registrar=()=>{
        let method='POST'
        let url_add=''


        const formData = new URLSearchParams();
        formData.append("affected_interface_id", host.interfaceid);

        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/actions/relations/'+tecSelected.action_id, {
             method: method,  
             headers: {
                 "Accept": "application/json",
                 "Content-Type": "application/x-www-form-urlencoded",
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
               body: formData
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             // setData(data1)
             // console.log(data1);
             
         //   setRegisterIsValid(true)
           
           
         
           } else {
               const data = await response.json();
               // setRegisterIsValid(false)
               // setResponseDetail({text:data.detail,value:false})
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
              setHostName("")
              // setCisData({ip:"",host_id:0,date:"",responsible_name:"",auth_name:"",device_description:"",justification:"",previous_state:"",new_state:"",impact:"",result:"",observations:"",files:[],status:'Activo'})
              // setRegisterIsValid(false)
          setLoading(false)
           
          }
        };

        fetchDataPost();
    }

    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/actions/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
             
             const data1 = await response.json();
             if(data1.data.length>0){
                 setLoadingM(false)
                 sethost(data1.data[0])
                 setDisabled(true)
             }else{
                 setIpValid(false)
             }
             
           } else {
             // const data1 = await response.json();
             // console.log(data1)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }

    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setMsgError('Direccion ip no valida')
        }
        return result;
    };
    const changeOption=(option,index)=>{}
    // const {ip,host_id,folio,technology,device_name,description,location,criticality,status}=cisData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                {/* <div className='head-card-RelationTechDevice-modal-create'>
                    <div className='title-head-card-users'>
                        {'Crear relacion con la acción id: '+tecSelected.action_id}
                    </div>
                </div> */}
                <div className='content-card-modal-gs' >
                
                                    <div className="form-GS-box"> 
                                    
                                    <div className="user-box-GS" style={{top:'7%'}}>
                                    <input required name="ip"  type="text" value={ip}
                                    onChange={handleChange} />
                                        <label className='label-GS'style={{top:'-80% '}} >Host IP</label>
                                        {
                                            IpValid?'':<span className='form-msg-error-gr'> {msgError}</span>
                                        }
                                        
                                    </div>
                                    <div className='cont-RelationTechDevice-info-gs' style={{height:'60%',top: '10%',position: 'relative'}}>
                    <div className='row-RelationTechDevice-info-gs'>
                        <div className='cont-title-RelationTechDevice-info-gs'>
                            <div className='title-RelationTechDevice-info-gs'>
                                Host ID
                            </div>
                        </div>
                        <div className='cont-box-RelationTechDevice-info-gs'>
                            <div className='box-RelationTechDevice-info-gs'>
                                {(loadingM)?'...':host.hostid}
                            </div>
                        </div>
                    </div>
                    
                    <div className='row-RelationTechDevice-info'>
                        <div className='cont-title-RelationTechDevice-info-gs' style={{width:'10%'}}>
                            <div className='title-RelationTechDevice-info-gs'>
                                Host
                            </div>
                        </div>
                        <div className='cont-box-RelationTechDevice-info-gs' style={{width:'90%'}}>
                            <div className='box-RelationTechDevice-info-gs' style={{fontSize:'x-small'}}>
                                {(loadingM)?'...':host.name}
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="user-box-GS" style={{height:'25%',top: '-7%'}}>
                <label className='title-RelationTechDevice-info-gs' style={{width: '15%'}}>Severidad</label> 
                <div className='box-RelationTechDevice-info-gs' style={{background:'transparent',display:'flex',justifyContent:'center',alignItems:'center',border:'none'}}> {
                                            (dataCriticalities.loading)? (
                                                '...'
                                              ) : <>
                                              <div style={{display:'flex',width:'20%',height: '100%',justifyContent:'center',alignItems:'center'}}>
                                                      <input type='radio' className='input-radio-gs' name='severity' key={'radio_severity_' + 0} title='N/A' value={0} checked={(severity==0)?true:false} onClick={()=>{setSeverity(0)}}/>
                                                      <label htmlFor={'N/A'}className='input-radio-gs-label' >{'N/A'}</label><br></br>
                                                      </div>
                                              {
                                                (
                                                    dataCriticalities.data.data.map((elemento, indice) => (
                                                      <div style={{display:'flex',width:'20%',height: '100%',justifyContent:'center',alignItems:'center'}}>
                                                      <input type='radio' className='input-radio-gs' name='severity' key={'radio_severity_' + indice} title={elemento.name} value={indice} onClick={()=>{setSeverity(elemento.cassia_criticality_id)}} />
                                                      <label htmlFor={elemento.name} className='input-radio-gs-label'>{elemento.name}</label><br></br>
                                                      </div>
                                                    ))
                                                  )
                                              }
                                              
                                              </>
                                            // <SelectorAdmin placeholder={'Seleccionar agencia...'} opGeneral={true} txtOpGen={'N/A'}  opt_de={0} origen={'Admin'} data={dataCriticalities.data.data} loading={dataCriticalities.loading}  titulo='Severity' selectFunction={changeOption} index={0}></SelectorAdmin>

                                        }</div>
                                       
                                        
                                    </div>
                                    
                                    <div className="user-box-GS" style={{top: '-2%',height:'10%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={disabled} origen='Azul' titulo='Agregar'  action={Agregar}/>
                                            <Action disabled={false} origen='Cancelar' titulo='Borrar'  action={Borrar}/>
                                            </>
                                           
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateRelationTechDevice